import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// TEMP: Remap Doc App URLs from old Doc App to React-Redux Doc App
const urlMap = url => {
	switch (url) {
		case '#date-time-formatting':
			return '/widgets/customize#date-time-formatting';
		case '#date-time-callback':
			return '/widgets/customize#date-time-callback';
		case '#post-image-sizes':
			return '/widgets/customize#post-image-sizes';
		case '#user-image-sizes':
			return '/widgets/customize#user-image-sizes';
		case 'api#GET_v1_post':
			return '/api/Posts#get-post-id';
		case 'api#GET_v1_stream':
			return '/api/Streams#get-stream';
		case 'api#postResponse_response':
			return '/api/responses/postResponse';
		case 'api#GET_v1_community_info':
			return '/api/Community#get-community-info';
		default:
			break;
	}

	return url;
};

// A single "line" of the description in the form: text<Link>, where Link is optional
const linkLine = (index, text, linkText, linkUrl) =>
	(<span key={index}>{text}
		{linkText && linkUrl &&
			<Link to={urlMap(linkUrl)}>{linkText}</Link>
		}
	</span>);

// Presentational Component
const WidgetDescription = ({ desc }) => {
	const urlRegEx = /\[([^|]+)+\|([^\]]+)\]/g; // Looking for [linkText|linkUrl] in description
	let match = urlRegEx.exec(desc);
	let summary = desc;
	let start = 0;
	let lines = [];

	// Are there any links in the description of form [linkText|linkUrl]?
	if (match !== null) {

		// Gather all the lines: text link
		while (match !== null) {
			lines.push({ start: start, text: match.input.substring(start, match.index), linkText: match[1], linkUrl: match[2] });
			start = match.index + match[0].length;
			match = urlRegEx.exec(desc); // Get next match (or null)
		}

		// Add rest of summary after last link
		lines.push({ text: desc.substr(start) });

		// Reassemble lines into rebuilt summary
		summary = lines.map((line, index) =>
			linkLine(index, line.text, line.linkText, line.linkUrl)
		);
	}

	return (
		<span>
			{summary}
		</span>
	);
};

WidgetDescription.propTypes = {
	desc: PropTypes.string.isRequired
};

export default WidgetDescription;



// WEBPACK FOOTER //
// ./src/components/widgets/WidgetDescription.js